module.exports = __webpack_public_path__ + "static/media/image.3b7d3730.png";